import { Outlet } from "react-router-dom";

import { OfflineBanner } from "@/components/ui/OfflineBanner";

import { BottomNav } from "./BottomNav";
import { Footer } from "./Footer";
import { Header } from "./Header";

export function PublicLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-paper text-ink">
      <Header />
      <OfflineBanner />
      <main className="container-page flex-1 pb-24 sm:pb-8">
        <Outlet />
      </main>
      <Footer />
      <BottomNav />
    </div>
  );
}
